<template>
  <section>
    <div class="columns" v-for="(provider, index) in data" :key="index">
      <div class="column">
        <b-field class="field" label="Live" horizontal>
          <b-input v-model="provider.live.source"/>
        </b-field>
        <b-field class="field" label="Prelive" horizontal>
          <b-input v-model="provider.prelive.source"/>
        </b-field>
      </div>
      <div class="column">
        <b-field class="field" label="Url" horizontal>
          <b-input v-model="provider.live.url"/>
        </b-field>
        <b-field class="field" label="Url" horizontal>
          <b-input v-model="provider.prelive.url"/>
        </b-field>
      </div>
      <div class="column">
        <b-field class="field" label="Name" horizontal>
          <b-input v-model="provider.live.name"/>
        </b-field>
        <b-field class="field" label="Name" horizontal>
          <b-input v-model="provider.prelive.name"/>
        </b-field>
      </div>
      <div class="column is-narrow">
        <button class="button is-primary" type="button" @click="removeSource(index)">
          <b-icon icon="minus"/>
        </button>
      </div>
    </div>
    <b-field horizontal class="field">
      <button class="button is-primary" type="button" @click="addSource">Add source</button>
    </b-field>
  </section>
</template>

<script>
export default {
  name: 'exchange-sources',
  props: ['value'],
  computed: {
    data() {
      return this.value || []
    },
  },
  methods: {
    addSource() {
      const newItem = {
        live: { source: '', url: '', name: '' },
        prelive: { source: '', url: '', name: '' },
      }

      if (Array.isArray(this.value)) {
        this.value.push(newItem)
      } else {
        this.$emit('input', [newItem])
      }
    },
    removeSource(index) {
      this.value.splice(index, 1)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/ExchangeSources.vue